<div class="formulario-container">
  <div class="label-container">
    <!-- <h1>Model Input</h1> -->
    <h3>Click "Save" after correcting the highlighted fields</h3>
  </div>
  <div class="submit-row">
    <button 
      type="submit" 
      [style.background-color]="submitButtonColor"
      [disabled]="loading"
      (click)="onSubmit()">
      {{ loading ? 'Loading...' : 'Save' }}
    </button>
    @if (saveSuccess) {
      <span class="save-message success">{{ saveMessage }}</span>
    }
  </div>
  <section class="vm-ppd-row">
    <div class="vm">
      <table>
        <thead>
          <tr>
            @for (header of vmHeaders; track header) {
            <th>{{ header }}</th>
            }
          </tr>
        </thead>
        <tbody>
          @for (group of vmForm.controls; track $index; let i = $index) {
            @if (hasValidTreat(group.get('name')?.value)) {
          <tr [formGroup]="group">
            <td>{{ group.get('name')?.value }}</td>
            <td><input type="text" formControlName="SSI30" [class.highlight-nan]="group.get('SSI30')?.value === 'NaN'" (focus)="group.get('SSI30')?.value === 'NaN' && group.patchValue({SSI30: ''})" (blur)="onBlurFormat(group, 'SSI30', 2)" /></td>
            <td><input type="text" formControlName="SSI90" [class.highlight-nan]="group.get('SSI90')?.value === 'NaN'" (focus)="group.get('SSI90')?.value === 'NaN' && group.patchValue({SSI90: ''})" (blur)="onBlurFormat(group, 'SSI90', 2)" /></td>
            <td><input type="text" formControlName="KV100" [class.highlight-nan]="group.get('KV100')?.value === 'NaN'" (focus)="group.get('KV100')?.value === 'NaN' && group.patchValue({KV100: ''})" (blur)="onBlurFormat(group, 'KV100', 2)" /></td>
            <td><input type="text" formControlName="KV40" [class.highlight-nan]="group.get('KV40')?.value === 'NaN'" (focus)="group.get('KV40')?.value === 'NaN' && group.patchValue({KV40: ''})" (blur)="onBlurFormat(group, 'KV40', 2)" /></td>
            <td><input type="text" formControlName="NOACK" [class.highlight-nan]="group.get('NOACK')?.value === 'NaN'" (focus)="group.get('NOACK')?.value === 'NaN' && group.patchValue({NOACK: ''})" (blur)="onBlurFormat(group, 'NOACK', 2)" /></td>
          </tr>
            }
          }
        </tbody>
      </table>
    </div>
    <!-- <div class="ppd">
      <table>
        <thead>
          <tr>
            @for (header of ppdHeaders; track header) {
            <th>{{ header }}</th>
            }
          </tr>
        </thead>
        <tbody>
          @for (group of vmForm.controls; track $index; let i = $index) {
            @if (hasValidTreat(group.get('name')?.value)) {
          <tr [formGroup]="group">
            
          </tr>
            }
          }
        </tbody>
      </table>
    </div> -->
  </section>
  <section>
    <div>
      <table>
        <thead>
          <tr>
            @for (header of baseOilHeaders; track header) {
            <th>{{ header }}</th>
            }
          </tr>
        </thead>
        <tbody>
          @for (group of baseOilForm.controls; track $index; let i = $index) {
            @if (hasValidRatio(group.get('name')?.value, group.get('batch')?.value)) {
          <tr [formGroup]="group">
            <td>{{ group.get('name')?.value }}</td>
            <td><input type="text" formControlName="batch" class="disabled-field" title="User input not required here" /></td>
            <td><input type="text" formControlName="group" class="disabled-field" title="User input not required here" /></td>
            <td><input type="text" formControlName="saturate" [class.highlight-nan]="group.get('saturate')?.value === 'NaN'" (focus)="group.get('saturate')?.value === 'NaN' && group.patchValue({saturate: ''})" (blur)="onBlurFormat(group, 'saturate', 2)" /></td>
            <td><input type="text" formControlName="sulfur" [class.highlight-nan]="group.get('sulfur')?.value === 'NaN'" (focus)="group.get('sulfur')?.value === 'NaN' && group.patchValue({sulfur: ''})" (blur)="onBlurFormat(group, 'sulfur', 4)" /></td>
            <td><input type="text" formControlName="KV100" [class.highlight-nan]="group.get('KV100')?.value === 'NaN'" (focus)="group.get('KV100')?.value === 'NaN' && group.patchValue({KV100: ''})" (blur)="onBlurFormat(group, 'KV100', 2)" /></td>
            <td><input type="text" formControlName="KV40" [class.highlight-nan]="group.get('KV40')?.value === 'NaN'" (focus)="group.get('KV40')?.value === 'NaN' && group.patchValue({KV40: ''})" (blur)="onBlurFormat(group, 'KV40', 2)" /></td>
            <td><input type="text" formControlName="VI" [class.highlight-nan]="group.get('VI')?.value === 'NaN'" (focus)="group.get('VI')?.value === 'NaN' && group.patchValue({VI: ''})" (blur)="onBlurFormat(group, 'VI', 0)" /></td>
            <td><input type="text" formControlName="NOACK" [class.highlight-nan]="group.get('NOACK')?.value === 'NaN'" (focus)="group.get('NOACK')?.value === 'NaN' && group.patchValue({NOACK: ''})" (blur)="onBlurFormat(group, 'NOACK', 2)" /></td>
            <td><input type="text" formControlName="CCS10" class="disabled-field" title="User input not required here" /></td>
            <td><input type="text" formControlName="CCS15" class="disabled-field" title="User input not required here" /></td>
            <td><input type="text" formControlName="CCS20" [class.highlight-nan]="group.get('CCS20')?.value === 'NaN'" (focus)="group.get('CCS20')?.value === 'NaN' && group.patchValue({CCS20: ''})" (blur)="onBlurFormat(group, 'CCS20', 0)" /></td>
            <td><input type="text" formControlName="CCS25" [class.highlight-nan]="group.get('CCS25')?.value === 'NaN'" (focus)="group.get('CCS25')?.value === 'NaN' && group.patchValue({CCS25: ''})" (blur)="onBlurFormat(group, 'CCS25', 0)" /></td>
            <td><input type="text" formControlName="CCS30" [class.highlight-nan]="group.get('CCS30')?.value === 'NaN'" (focus)="group.get('CCS30')?.value === 'NaN' && group.patchValue({CCS30: ''})" (blur)="onBlurFormat(group, 'CCS30', 0)" /></td>
            <td><input type="text" formControlName="CCS35" class="disabled-field" title="User input not required here" /></td>
          </tr>
            }
          }
        </tbody>
      </table>
    </div>
  </section>
  <section>
    <div class="additives-table">
      <div class="table-header">
        <span>Additives</span>
        <span>Dosage</span>
        <span>Unit</span>
        <span>Family</span>
        <span>Metal</span>
        <span>Typical Metal %</span>
      </div>
      <div class="table-row" *ngFor="let item of additives">
        <p class="cell">{{ toNaNIfEmpty(item.name) }}</p>
        <p class="cell">
          {{ isNaNDisplay(item.dosage) ? 'NaN' : ((+item.dosage === 0 || item.dosage === '0.0') ? '0' : (item.dosage | number : '1.2-4')) }}
        </p>
        <p class="cell">{{ toNaNIfEmpty(item.unit) }}</p>
        <p class="cell">{{ toNaNIfEmpty(item.family) }}</p>
        <p class="cell">{{ toNaNIfEmpty(item.metal) }}</p>
        @if (!isNaNDisplay(item.typicalMetal)) {
        <p class="cell">{{ (+item.typicalMetal === 0 || item.typicalMetal === '0.0') ? '0' : (item.typicalMetal | number : '1.2-4') }}</p>
        } @else {
        <p class="cell">NaN</p>
        }
      </div>
    </div>
  </section>
</div>
